import type { ScreenEventPayload, UIEventPayload } from '@atlassiansox/analytics-web-client';
import { useTenantData } from '@dev-agents/tenant-context';
import { useCallback } from 'react';

import { useAnalyticsWebClient } from '../utils/analytics/context';
import { useUserPermData } from '../utils/user-perm-context';

export const useRovoDevWebAnalyticsClient = () => {
	const { tenantContexts } = useTenantData();
	const currentTenantContext = tenantContexts[0];
	const { rovoDevAgentsUser } = useUserPermData();
	const { sendUIEvent, sendScreenEvent } = useAnalyticsWebClient();

	const fireUiEvent = useCallback(
		(eventPayload: UIEventPayload) => {
			const commonAttrs = {
				orgId: currentTenantContext.orgId,
				isAdmin: rovoDevAgentsUser.isAdmin,
			};
			const extendedPayload = {
				...eventPayload,
				attributes: {
					...eventPayload.attributes,
					...commonAttrs,
				},
			};
			sendUIEvent(extendedPayload);
		},
		[currentTenantContext.orgId, rovoDevAgentsUser.isAdmin, sendUIEvent],
	);

	const fireScreenEvent = useCallback(
		(eventPayload: ScreenEventPayload) => {
			const commonAttrs = {
				orgId: currentTenantContext.orgId,
				isAdmin: rovoDevAgentsUser.isAdmin,
			};
			const extendedPayload = {
				...eventPayload,
				attributes: {
					...eventPayload.attributes,
					...commonAttrs,
				},
			};
			sendScreenEvent(extendedPayload);
		},
		[currentTenantContext.orgId, rovoDevAgentsUser.isAdmin, sendScreenEvent],
	);

	return {
		fireUiEvent,
		fireScreenEvent,
	};
};
